import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import "react-toastify/dist/ReactToastify.css";
import Error from "../components/Error/Error";

const Error404 = () => {
  const [isOpen, setIsopen] = useState(false);

  const toogle = () => {
    setIsopen(!isOpen);
  };

  const [currentLanguage, setCurrentLanguage] = useState("es");

  const handleLanguageChange = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toogle={toogle} />
      <Navbar
        toogle={toogle}
        isOpen={isOpen}
        currentLanguage={currentLanguage}
        onChangeLanguage={handleLanguageChange}
        />
        <Error />
    </>
  );
};

export default Error404;
